import React from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const handleSettings = () => {
    navigate('/configurations');
  };

  return (
    <>
      <Navbar bg="light" expand="lg">
        <Container>
          <Navbar.Brand href="#home">Student Management</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {user ? (
                <>
                  <Navbar.Text className="mr-3">
                    Welcome, {user.username}!
                  </Navbar.Text>
                  
                  <Button variant="outline-danger" onClick={handleLogout}>Logout</Button>
                </>
              ) : (
                <Button variant="outline-primary" onClick={() => navigate('/login')}>Login</Button>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Thanh chức năng dưới Header */}
      {user && (
        <Navbar bg="primary" variant="dark">
          <Container>
            <Nav className="mr-auto">
              {/* Chỉ hiện với admin */}
              {user.role === 'admin' && (
                <>
                  <Nav.Link onClick={() => navigate('/students')}>DS Trúng tuyển</Nav.Link>
                  <Nav.Link onClick={() => navigate('/manage-majors')}>Ngành / lớp nhập học</Nav.Link>
                  <Nav.Link onClick={() => navigate('/enrollments')}>Danh sách nhập học</Nav.Link>
                  <Nav.Link onClick={() => navigate('/configurations')}>Cấu hình</Nav.Link>
                  <Nav.Link onClick={() => navigate('/manage-users')}>Quản lý người dùng</Nav.Link>
                  <Nav.Link onClick={() => navigate('/logs')}>Nhật kí hệ thống</Nav.Link>
                </>
              )}
              {/* Chỉ hiện với admin hoặc manager */}
              {['admin', 'manager'].includes(user.role) && (
                <Nav.Link onClick={() => navigate('/student-reception')}>Nhập học cho sinh viên</Nav.Link>
              )}
            </Nav>
          </Container>
        </Navbar>
      )}
    </>
  );
};

export default Header;
